define("shared/components/shared/profile-categorization/categorize-steps/progress-bar/component", ["exports", "@ember/component", "@ember/object", "shared/components/shared/profile-categorization/categorize-steps/progress-bar/template"], function (_exports, _component, _object, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component",0,"@ember/object",0,"shared/components/shared/profile-categorization/categorize-steps/progress-bar/template"eaimeta@70e063a35619d71f

  var _default = _component.default.extend({
    layout: _template.default,
    progressClass: (0, _object.computed)('progressValue', function () {
      const value = Number(this.progressValue.toFixed(1)) * 10;
      return "tSC--avatar__loader".concat(value);
    })
  });

  _exports.default = _default;
});